<script setup lang="ts">
import SignalDot from './SignalDot.vue';
import type { StatusKey } from './icons';

const props = defineProps<{
  value: StatusKey;
}>();
const emit = defineEmits<{ change: [v: StatusKey] }>();

const segs: { id: StatusKey; label: string }[] = [
  { id: 'online', label: '接客' },
  { id: 'away', label: '不接客' },
];
</script>

<template>
  <div class="wb-status-switch">
    <button
      v-for="s in segs"
      :key="s.id"
      type="button"
      :class="['wb-status-seg', s.id, value === s.id ? 'on' : '']"
      :aria-pressed="value === s.id"
      @click="value !== s.id && emit('change', s.id)"
    >
      <SignalDot :status="s.id" />
      {{ s.label }}
    </button>
  </div>
</template>
